<template>
  <component :is="layoutComponent" v-bind="layoutProps">
    <template slot="field">
      <a v-if="fieldValue" :href="fieldValue.url" target="_blank">
        <img :src="thumb(fieldValue, 200, 100)" />
      </a>
    </template>
  </component>
</template>

<script>
import { FormField } from 'stylemix-base'

export default {
  name: 'ImgField',

  extends: FormField,
}
</script>
